export const getDestinationIcon = (code) => {
    switch (code) {
        case "Web Service":
            return "/assets/images/typeImages/lead/destinations/web-service.png";
        case "Zoho CRM":
            return "/assets/images/typeImages/lead/destinations/zoho.png";
        case "Salesforce":
            return "/assets/images/typeImages/lead/destinations/salesforce.png";
        case "Microsoft Dynamics":
            return "/assets/images/typeImages/lead/destinations/microsoft-dynamics-logo.png";
        case "High Level":
            return "/assets/images/typeImages/lead/destinations/highlevel.png";
        case "Sugar CRM":
            return "/assets/images/typeImages/lead/destinations/sugar.png";
        case "Odoo":
            return "/assets/images/typeImages/lead/destinations/odoo.png";
        case "Perfex":
            return "/assets/images/typeImages/lead/destinations/perfex.png";
        case "Fresh Sales":
            return "/assets/images/typeImages/lead/destinations/freshsales-crm.png";
        case "Vtiger":
            return "/assets/images/typeImages/lead/destinations/vtiger-crm.png";
        case "Wati":
            return "/assets/images/typeImages/lead/destinations/wati.png";
        case "Monday":
            return "/assets/images/typeImages/lead/destinations/monday.png";
        case "Hubspot":
            return "/assets/images/typeImages/lead/destinations/hubspot-icon.png";
        case "Zendesk":
            return "/assets/images/typeImages/lead/destinations/zendesk-icon.png";
        case "Bitrix 24":
        case "b24":
            return "/assets/images/typeImages/b24.png";
        case "Google BigQuery":
        case "bigquery":
            return "/assets/images/typeImages/bigquery.png";
        case "Google Sheets":
        case "google-sheets":
            return "/assets/images/typeImages/google-sheets-icon.png";
        default:
            return "";
    }
};
